import * as microsoftTeams from "@microsoft/teams-js";

export const openUserChat = (upn: string) => {
	if (microsoftTeams.chat.isSupported() && !!upn && upn.length > 0) {
		microsoftTeams.chat
			.openGroupChat({ users: [upn] })
			.then((result) => console.log(result))
			.catch((error) => console.error(error));
	} else {
		console.error("Chat is not supported");
	}
};
